module.exports = __webpack_public_path__ + "static/media/furqan-1.108d11b8.jpg";